import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Widgets from "../../Widgets";
import { useTranslation } from "react-i18next";
import strings from "../../Utils/strings";
import "./DoctorLogin.css";

const ForgotPassword = () => {
  const [isLoading, setIsLoading] = useState(false);
  const { t } = useTranslation();
  const nav = useNavigate();

  const [formData, setFormData] = useState({
    username: "",
  });
  const [usernameError, setUsernameError] = useState("");

  const formDataChangeHandler = (e) => {
    setFormData({ ...formData, [e.target.id]: e.target.value });
  };

  const handleLogin = async (event) => {
    event.preventDefault();
    // await LoginApiCall(formData, remember, setIsLoading, setUsernameError, setPassError, dispatch);
  };

  return (
    <>
      {isLoading ? <Widgets.CircularLoader /> : ""}
      <div className="detail-container">
        <div>
          <h5 className="login-title">{t("forgotPassHeading")}</h5>
        </div>
        <form>
          <div className="relative mt-6">
            <div className={"flex "}>
              <input
                onChange={(e) => {
                  formDataChangeHandler(e);
                  setUsernameError("");
                }}
                onKeyDown={(e) => {
                  if (e.key === " ") {
                    e.preventDefault();
                  }
                }}
                type="text"
                name="username"
                id="username"
                className={"bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg block w-full p-2.5"}
                placeholder={t("usernamePlaceholder")}
                required=""
              />
            </div>
            {usernameError ? <span className="errorMsg">{usernameError}</span> : null}
          </div>
          <button disabled={isLoading} onClick={handleLogin} className="buttonStyle mt-4 w-full text-white font-medium rounded-lg text-sm px-5 py-2.5 text-center">
            {isLoading ? t("loading") : t("continue")}
          </button>
        </form>

        <div
          className="mt-4 flex justify-center cursor-pointer"
          onClick={() => {
            nav(strings.navigation.doctorLogin);
          }}
        >
          <p className="font-medium text-[.8rem] text-black">{t("alreadyHaveAccount")}</p>
          <p className="ml-1 font-medium text-[.8rem] text-grey">{t("loginForget")}</p>
        </div>
      </div>
    </>
  );
};

export default ForgotPassword;
